import * as m from "../../es2015/plugins/forceDirected";
window.am4plugins_forceDirected = m;


//////////////////
// WEBPACK FOOTER
// ./plugins/forceDirected.js
// module id = null
// module chunks = 